import { EntityEditFormModal } from '../../Entity'

import { USER_STAFF_EDIT_FUNCTIONAL_ROLE_MODAL_QA_NAME } from './UserStaffEditFunctionalRoleFormModal.constants'
import {
  getUserStaffEditFunctionalRoleFormModalSubmitPayload,
  getUserStaffEditFunctionalRoleFormModalValidationSchema,
} from './UserStaffEditFunctionalRoleFormModal.utils'
import { UserStaffEditFunctionalRoleFormModalFields } from './UserStaffEditFunctionalRoleFormModalFields'

function UserStaffEditFunctionalRoleFormModal({
  Fields = UserStaffEditFunctionalRoleFormModalFields,
  formTitleKey = 'UserProfile.EditFunctionalRoleModalTitleKey',
  getPayload = getUserStaffEditFunctionalRoleFormModalSubmitPayload,
  initialValues,
  ...restProps
}) {
  const validationSchema =
    getUserStaffEditFunctionalRoleFormModalValidationSchema(initialValues)

  return (
    <EntityEditFormModal
      {...restProps}
      Fields={Fields}
      formTitle={formTitleKey}
      getPayload={getPayload}
      initialValues={initialValues}
      qaName={USER_STAFF_EDIT_FUNCTIONAL_ROLE_MODAL_QA_NAME}
      validationSchema={validationSchema}
    />
  )
}

export default UserStaffEditFunctionalRoleFormModal
